<template>
  <v-card flat>
    <div class="px-4">
      <v-col
        class="py-0 pa-2 pb-1"
        @click="handleBack"
        style="cursor: pointer"
        cols="12"
      >
        <span
          color="primary"
          class="no-hover"
          icon
          :disabled="
            loadingSkipButton ||
            loadingDeletePauseThumb ||
            loadingPauseThumbnail
          "
          style="width: 18px"
        >
          <v-icon
            class="body-bold-smaller color-back"
            size="12"
            height="12px"
            width="11px"
            >mdi-arrow-left</v-icon
          >
        </span>
        <span
          class="body-bold-smaller color-back"
          style="vertical-align: middle; color: #697af2"
        >
          {{ $t('message.actions.return') }}
        </span>
      </v-col>

      <v-container
        :class="{
          'd-none': !loadingSlider,
        }"
      >
        <v-row class="d-flex">
          <v-col cols="12">
            <div class="skeleton-btn-loader-container">
              <v-skeleton-loader
                class="border pr-5 skeleton-button"
                type="heading"
              ></v-skeleton-loader>
            </div>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader
              class="border loader-width pr-5 skeleton-slider"
              type="list-item-three-line"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader
              class="border loader-width pr-5 skeleton-slider"
              type="divider"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader
              class="border pr-5 skeleton-button"
              type="sentences"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader
              class="border loader-width pr-5 skeleton-slider"
              type="divider"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader
              class="border pr-5 skeleton-button"
              type="sentences"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader
              class="border loader-width pr-5 skeleton-slider"
              type="divider"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader
              class="border pr-5 skeleton-button"
              type="sentences"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>

      <div
        :class="{
          'd-none': loadingSlider,
        }"
      >
        <v-row class="py-0 pa-2">
          <v-col cols="12">
            <v-card flat>
              <div><span class="body-bold-medium">Thumbnails</span></div>
              <span class="body-regular-smaller subTitle-enable-thumb">
                {{ $t('message.pages.video.thumbnails.subtitle') }}
              </span>
              <a
                target="_blank"
                type="secondary"
                :href="$t('message.pages.video.thumbnails.linkLearnMore')"
              >
                <span class="body-bold-smaller">
                  {{ $t('message.knowMore') }}
                </span>
                <v-icon class="body-bold-smaller" size="12"
                  >mdi-open-in-new</v-icon
                >
              </a>
            </v-card>
          </v-col>
        </v-row>

        <v-col cols="12" class="mt-8 mb-0 pa-1">
          <v-row class="px-4">
            <span class="body-bold-base mb-2">
              {{ $t('message.pages.video.thumbnails.start') }}
            </span>

            <BaseAlert
              class="mb-5 mr-4 py-4"
              style="width: 100%"
              v-if="smartAutoPlay"
              :title="$t('message.pages.video.smartPlayActive')"
              :description="$t('message.pages.video.smartPlayDescription')"
            >
            </BaseAlert>

            <v-col cols="12" style="display: grid">
              <BaseActionList title="thumbnail">
                <template #primary-action>
                  <div
                    class="d-flex flex-wrap align-center"
                    style="gap: 10px; cursor: pointer"
                    @click="
                      openUploadStart = isValidImage(defaultTempStartThumbnail)
                      selectedDefaultStart = defaultThumbnail
                    "
                  >
                    <template>
                      <previewThumbCard
                        v-if="isValidImage(defaultTempStartThumbnail)"
                        style="
                          height: 32px;
                          width: 48px;
                          min-width: 48px !important;
                        "
                        :loadingDelete="false"
                        :heightImage="'32px'"
                        :thumb="defaultTempStartThumbnail"
                        :showCloseBtn="false"
                        :selected="false"
                        :showDownloadBtn="false"
                      />
                      <previewThumbCard
                        v-else
                        style="
                          height: 32px;
                          width: 48px;
                          min-width: 48px !important;
                        "
                        :loadingDelete="false"
                        :heightImage="'32px'"
                        :thumb="imagePlaceholder"
                        :showCloseBtn="false"
                        :selected="false"
                        :showDownloadBtn="false"
                      />
                    </template>
                  </div>
                </template>

                <template #secondary-action>
                  <div v-if="!loadingRemoveDefault" class="d-flex align-center">
                    <!-- <v-tag
                  class="px-2"
                  type="disabled"
                  v-if="defaultTempStartThumbnail !== defaultThumbnail"
                >
                  <span color="">{{ $t('message.disabled') }}</span>
                </v-tag>
                <v-tag
                  v-else
                  size="small"
                  class="px-2"
                  style="border-radius: 20px"
                >
                  <span>{{ $t('message.pages.video.enabled') }}</span>
                </v-tag> -->

                    <v-tooltip
                      bottom
                      v-if="!isValidImage(defaultTempStartThumbnail)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-tag
                          class="mr-3"
                          v-bind="attrs"
                          v-on="on"
                          type="error"
                        >
                          {{ $t('message.error') }}
                        </v-tag>
                      </template>
                      <span>{{
                        $t('message.pages.video.thumbnails.errorThumb')
                      }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <base-btn
                          :disabled="loading"
                          v-if="
                            !filteredDefaultThumbsInfo.includes(
                              defaultThumbnail
                            )
                          "
                          class="panda-icons --thumbnail"
                          color="feedback-danger-background"
                        >
                          <v-icon
                            :disabled="loading"
                            v-bind="attrs"
                            v-on="on"
                            type="neutral"
                            class="panda-remove panda-icons --thumbnail"
                            icon="panda-remove"
                            color="feedback-danger"
                            @click="
                              loadingRemoveDefault = true
                              handleDeleteThumbnail('removeButton')
                            "
                            style="font-size: 16px"
                            >panda-remove</v-icon
                          >
                        </base-btn>
                        <base-btn
                          v-else
                          :disabled="loading"
                          v-bind="attrs"
                          v-on="on"
                          class="panda-icons --thumbnail edit-thumb-btn"
                          type="neutral"
                          @click="
                            openUploadStart = true
                            selectedDefaultStart = defaultTempStartThumbnail
                          "
                          ><v-icon
                            :disabled="loading"
                            style="
                              font-size: 16px;
                              color: var(--neutral-40-light-light) !important;
                            "
                            >panda-edit</v-icon
                          ></base-btn
                        >
                      </template>
                      <span
                        v-if="
                          !filteredDefaultThumbsInfo.includes(defaultThumbnail)
                        "
                        >{{ $t('message.pages.video.delete') }}</span
                      >
                      <span v-else>{{ $t('message.actions.edit') }}</span>
                    </v-tooltip>

                    <v-menu
                      v-if="isValidImage(defaultTempStartThumbnail)"
                      min-width="208px"
                      offset-y
                      bottom
                      left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <base-btn
                          type="neutral"
                          :disabled="loading"
                          class="panda-menu-action panda-icons --thumbnail edit-thumb-btn"
                          v-bind="attrs"
                          v-on="on"
                          color="neutral-light"
                          style="font-size: 16px"
                        />
                      </template>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-title
                            @click="
                              openUploadStart = true
                              selectedDefaultStart = defaultTempStartThumbnail
                              showPreviewImgStart =
                                !filteredDefaultThumbsInfo.includes(
                                  defaultThumbnail
                                )
                            "
                          >
                            {{ $t('message.pages.video.thumbnails.editThumb') }}
                          </v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item>
                      <v-list-item-title>
                        <base-btn
                          @click="handleDefaultThumbTemp(defaultThumbnail)"
                          type="neutral"
                          class="text-none"
                          :disabled="
                            defaultThumbnail == defaultTempStartThumbnail
                          "
                          >{{
                            $t('message.pages.video.thumbnails.activeThumb')
                          }}</base-btn
                        >
                      </v-list-item-title>
                    </v-list-item> -->
                        <v-list-item>
                          <v-list-item-title
                            @click="
                              handleDownloadThumb(
                                defaultTempStartThumbnail,
                                'thumbnail'
                              )
                            "
                          >
                            {{
                              $t('message.pages.video.thumbnails.downloadThumb')
                            }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          :class="{
                            'disabled-v-list-item':
                              filteredDefaultThumbsInfo.includes(
                                defaultThumbnail
                              ),
                          }"
                        >
                          <v-tooltip
                            bottom
                            :disabled="
                              !filteredDefaultThumbsInfo.includes(
                                defaultThumbnail
                              )
                            "
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-list-item-title
                                v-if="
                                  filteredDefaultThumbsInfo.includes(
                                    defaultThumbnail
                                  )
                                "
                                v-bind="attrs"
                                v-on="on"
                                :class="{
                                  'disabled-v-list-item-title':
                                    filteredDefaultThumbsInfo.includes(
                                      defaultThumbnail
                                    ),
                                }"
                              >
                                {{
                                  $t(
                                    'message.pages.video.thumbnails.deleteThumb'
                                  )
                                }}
                              </v-list-item-title>
                              <v-list-item-title
                                v-else
                                v-bind="attrs"
                                v-on="on"
                                :class="{
                                  'disabled-v-list-item-title':
                                    filteredDefaultThumbsInfo.includes(
                                      defaultThumbnail
                                    ),
                                  'remove-v-list-item-title':
                                    !filteredDefaultThumbsInfo.includes(
                                      defaultThumbnail
                                    ),
                                }"
                                @click="handleDeleteThumbnail('removeButton')"
                              >
                                {{
                                  $t(
                                    'message.pages.video.thumbnails.deleteThumb'
                                  )
                                }}
                              </v-list-item-title>
                            </template>
                            <span>{{
                              $t(
                                'message.pages.video.thumbnails.alertDeleteDisable'
                              )
                            }}</span>
                          </v-tooltip>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                  <div v-else class="d-flex align-center">
                    <v-progress-circular
                      indeterminate
                      :size="16"
                      :width="3"
                      color="brand"
                    ></v-progress-circular>
                  </div>
                </template>
              </BaseActionList>

              <v-row class="mt-4">
                <base-btn
                  size="small"
                  type="secondary"
                  v-if="
                    hasEditVideoPerm &&
                    filteredDefaultThumbsInfo.includes(defaultThumbnail)
                  "
                  :disabled="loading"
                  @click="openUploadStart = true"
                >
                  <v-icon>mdi-plus</v-icon>
                  {{ $t('message.pages.video.thumbnails.addThumb') }}
                </base-btn>
                <v-tooltip v-else bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <base-btn
                      type="secondary"
                      size="small"
                      v-bind="attrs"
                      v-on="on"
                      disabled
                      @click="openUploadStart = true"
                    >
                      <v-icon>mdi-plus</v-icon>
                      {{ $t('message.pages.video.thumbnails.addThumb') }}
                    </base-btn>
                  </template>
                  <span>{{
                    $t('message.pages.video.thumbnails.alertDisable')
                  }}</span>
                </v-tooltip>
                <v-file-input
                  v-model="newThumbnail.file"
                  v-if="!loading"
                  height="20px"
                  ref="fileInputStart"
                  class="d-flex align-center justify-center ma-0 pa-0 pl-2 file-input-start"
                  hide-input
                  prepend-icon=""
                  accept="image/png, image/jpeg, image/gif"
                  @change="handleChangeThumbnail"
                >
                </v-file-input>
              </v-row>
            </v-col>
          </v-row>

          <v-divider class="my-8"></v-divider>

          <v-row class="px-4">
            <span
              class="body-bold-base"
              :class="{
                'mb-4': !pauseThumbnails.length,
              }"
            >
              {{ $t('message.pages.video.thumbnails.pause') }}
            </span>

            <v-col cols="12" style="display: grid; gap: 10px">
              <BaseActionList
                v-for="(thumb, index) in pauseThumbnails"
                :key="`defaultThumb_${index}`"
                :title="thumb.metadata.thumb.title"
                :subtitle="`${formatTime(
                  thumb.metadata.thumb.startTime
                )} - ${formatTime(thumb.metadata.thumb.endTime)}`"
              >
                <template #primary-action>
                  <div
                    class="d-flex flex-wrap align-center"
                    style="gap: 10px; cursor: pointer"
                    @click="
                      isValidImage(thumb.metadata.fileUrl)
                        ? selectedPauseThumbnails(thumb)
                        : ''
                    "
                  >
                    <previewThumbCard
                      v-if="isValidImage(thumb.metadata.fileUrl)"
                      style="
                        height: 32px;
                        width: 48px;
                        min-width: 48px !important;
                      "
                      :key="`defaultThumb_${index}`"
                      :loadingDelete="false"
                      :heightImage="'32px'"
                      :thumb="thumb.metadata.fileUrl || defaultPauseThumbnail"
                      :showCloseBtn="false"
                      :selected="false"
                      :showDownloadBtn="false"
                    />
                    <previewThumbCard
                      v-else
                      style="
                        height: 32px;
                        width: 48px;
                        min-width: 48px !important;
                      "
                      :key="`defaultThumb_${index}+1`"
                      :loadingDelete="false"
                      :heightImage="'32px'"
                      :thumb="imagePlaceholder"
                      :showCloseBtn="false"
                      :selected="false"
                      :showDownloadBtn="false"
                    />
                  </div>
                </template>

                <template #secondary-action>
                  <div v-if="!thumb.removeThumb" class="d-flex align-center">
                    <v-tooltip
                      bottom
                      v-if="!isValidImage(thumb.metadata.fileUrl)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-tag
                          class="mr-3"
                          v-bind="attrs"
                          v-on="on"
                          type="error"
                        >
                          {{ $t('message.error') }}
                        </v-tag>
                      </template>
                      <span>{{
                        $t('message.pages.video.thumbnails.errorThumb')
                      }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <base-btn
                          v-bind="attrs"
                          v-on="on"
                          class="panda-icons --thumbnail edit-thumb-btn"
                          type="neutral"
                          :disabled="loading"
                        >
                          <v-icon
                            :disabled="loading"
                            style="
                              font-size: 16px;
                              color: var(--neutral-40-light-light) !important;
                            "
                            >panda-edit</v-icon
                          ></base-btn
                        >
                      </template>
                      <span>{{ $t('message.actions.edit') }}</span>
                    </v-tooltip>
                    <v-menu
                      v-if="isValidImage(thumb.metadata.fileUrl)"
                      min-width="208px"
                      offset-y
                      bottom
                      left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <base-btn
                          type="neutral"
                          class="panda-menu-action panda-icons --thumbnail edit-thumb-btn"
                          :disabled="loading"
                          v-bind="attrs"
                          v-on="on"
                          color="neutral-light"
                          style="font-size: 16px"
                        />
                      </template>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-title
                            @click="selectedPauseThumbnails(thumb)"
                          >
                            {{ $t('message.pages.video.thumbnails.editThumb') }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title
                            @click="
                              handleDownloadThumb(
                                thumb.metadata.fileUrl,
                                thumb.metadata.thumb.title
                              )
                            "
                          >
                            {{
                              $t('message.pages.video.thumbnails.downloadThumb')
                            }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title
                            @click="
                              thumb.removeThumb = true
                              handleRemoveThumb(thumb, index)
                            "
                            style="color: red !important"
                          >
                            {{
                              $t('message.pages.video.thumbnails.deleteThumb')
                            }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                  <div v-else class="d-flex align-center">
                    <v-progress-circular
                      indeterminate
                      :size="16"
                      :width="3"
                      color="brand"
                    ></v-progress-circular>
                  </div>
                </template>
              </BaseActionList>

              <v-row
                :class="{
                  'mt-4': pauseThumbnails.length,
                }"
              >
                <base-btn
                  type="secondary"
                  size="small"
                  v-if="hasEditVideoPerm"
                  :disabled="loading"
                  @click="openUploadPause = true"
                >
                  <v-icon>mdi-plus</v-icon>
                  {{ $t('message.pages.video.thumbnails.addThumb') }}
                </base-btn>
              </v-row>
            </v-col>
          </v-row>

          <v-divider class="my-8"></v-divider>

          <v-row class="px-4">
            <span
              class="body-bold-base mb-2"
              :class="{ 'mb-4': !defaultEndThumbnail }"
            >
              {{ $t('message.pages.video.thumbnails.end') }}
            </span>

            <v-col cols="12" style="display: grid; gap: 10px">
              <BaseActionList v-if="defaultEndThumbnail" title="thumbnail">
                <template #primary-action>
                  <div
                    class="d-flex flex-wrap align-center"
                    @click="openUploadEnd = isValidImage(defaultEndThumbnail)"
                    style="gap: 10px; cursor: pointer"
                  >
                    <previewThumbCard
                      v-if="isValidImage(defaultEndThumbnail)"
                      style="
                        height: 32px;
                        width: 48px;
                        min-width: 48px !important;
                      "
                      :heightImage="'32px'"
                      :loadingDelete="false"
                      :thumb="defaultEndThumbnail"
                      :showCloseBtn="false"
                      :showDownloadBtn="false"
                      :selected="false"
                    />
                    <previewThumbCard
                      v-else
                      style="
                        height: 32px;
                        width: 48px;
                        min-width: 48px !important;
                      "
                      :heightImage="'32px'"
                      :loadingDelete="false"
                      :thumb="imagePlaceholder"
                      :showCloseBtn="false"
                      :showDownloadBtn="false"
                      :selected="false"
                    />
                  </div>
                </template>

                <template #secondary-action>
                  <div v-if="!loadingRemoveEnd" class="d-flex align-center">
                    <v-tooltip bottom v-if="!isValidImage(defaultEndThumbnail)">
                      <template v-slot:activator="{ on, attrs }">
                        <v-tag
                          class="mr-3"
                          v-bind="attrs"
                          v-on="on"
                          type="error"
                        >
                          {{ $t('message.error') }}
                        </v-tag>
                      </template>
                      <span>{{
                        $t('message.pages.video.thumbnails.errorThumb')
                      }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <base-btn
                          :disabled="loading"
                          class="panda-icons --thumbnail"
                          color="feedback-danger-background"
                        >
                          <v-icon
                            :disabled="loading"
                            v-bind="attrs"
                            v-on="on"
                            type="neutral"
                            class="panda-remove panda-icons --thumbnail"
                            icon="panda-remove"
                            color="feedback-danger"
                            @click="handleDeleteEndThumbnail('removeButton')"
                            style="font-size: 16px"
                            >panda-remove</v-icon
                          >
                        </base-btn>
                      </template>
                      <span>{{ $t('message.pages.video.delete') }}</span>
                    </v-tooltip>
                    <v-menu
                      v-if="isValidImage(defaultEndThumbnail)"
                      min-width="208px"
                      offset-y
                      bottom
                      left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <base-btn
                          type="neutral"
                          class="panda-menu-action panda-icons --thumbnail edit-thumb-btn"
                          :disabled="loading"
                          v-bind="attrs"
                          v-on="on"
                          color="neutral-light"
                          style="font-size: 16px"
                        />
                      </template>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-title
                            @click="
                              openUploadEnd = true
                              showPreviewImgEnd = true
                            "
                          >
                            {{ $t('message.pages.video.thumbnails.editThumb') }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title
                            @click="
                              handleDownloadThumb(
                                defaultEndThumbnail,
                                'thumbnail'
                              )
                            "
                          >
                            {{
                              $t('message.pages.video.thumbnails.downloadThumb')
                            }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title
                            @click="handleDeleteEndThumbnail('removeButton')"
                            style="color: red !important"
                          >
                            {{
                              $t('message.pages.video.thumbnails.deleteThumb')
                            }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                  <div v-else class="d-flex align-center">
                    <v-progress-circular
                      indeterminate
                      :size="16"
                      :width="3"
                      color="brand"
                    ></v-progress-circular>
                  </div>
                </template>
              </BaseActionList>

              <v-row
                :class="{
                  'mt-4': defaultEndThumbnail,
                }"
              >
                <v-tooltip v-if="defaultEndThumbnail" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <base-btn
                      type="secondary"
                      size="small"
                      v-bind="attrs"
                      v-on="on"
                      disabled
                      @click="openUploadStart = true"
                    >
                      <v-icon>mdi-plus</v-icon>
                      {{ $t('message.pages.video.thumbnails.addThumb') }}
                    </base-btn>
                  </template>
                  <span>{{
                    $t('message.pages.video.thumbnails.alertDisable')
                  }}</span>
                </v-tooltip>
                <base-btn
                  :disabled="loading"
                  size="small"
                  type="secondary"
                  v-else-if="hasEditVideoPerm"
                  @click="openUploadEnd = true"
                >
                  <v-icon>mdi-plus</v-icon>
                  {{ $t('message.pages.video.thumbnails.addThumb') }}
                </base-btn>
                <v-file-input
                  v-if="!loadingEndThumbnail"
                  v-model="newEndThumbnail.file"
                  prepend-icon=""
                  height="20px"
                  ref="fileInputEnd"
                  class="d-flex align-center justify-center ma-0 pa-0 pl-2 file-input-end"
                  hide-input
                  accept="image/png, image/jpeg, image/gif"
                  @change="handleUploadEndThumbnail"
                ></v-file-input>
              </v-row>
            </v-col>
          </v-row>

          <!-- <v-card
          flat
          class="pt-2"
          v-if="successfulChangedThumb && !errors.updateThumbnailVideo"
        >
          <v-row
            no-gutters
            v-if="successfulChangedThumb && !errors.updateThumbnailVideo"
          >
            <v-col class="pa-0" style="max-width: min-content">
              <v-icon color="primary">mdi-check</v-icon>
            </v-col>
            <v-col class="pa-0">
              <span
                class="caption align-text"
                v-html="$t('message.pages.videoEditModal.serverUpdateOnUpload')"
              />
            </v-col>
          </v-row>

          <v-row
            no-gutters
            v-else-if="successfulDeleteThumb && !errors.updateThumbnailVideo"
          >
            <v-col class="pa-0" style="max-width: min-content">
              <v-icon color="primary">mdi-check</v-icon>
            </v-col>
            <v-col class="pa-0">
              <span
                class="caption align-text"
                v-html="$t('message.pages.video.serverDeleteThumbnail')"
              />
            </v-col>
          </v-row>

          <v-row
            no-gutters
            v-else-if="
              errors.updateThumbnailVideo &&
              !errors.thumbAboveMaxSize &&
              (editingThumbnail.type === 'start' ||
                editingThumbnail.type === 'end')
            "
          >
            <v-col class="px-2">
              <span
                class="caption align-text"
                style="color: #f44336"
                v-html="$t('message.pages.video.errors.updateThumbnail')"
              />
            </v-col>
          </v-row>

          <v-row
            no-gutters
            v-else-if="
              errors.updateThumbnailVideo &&
              errors.thumbAboveMaxSize &&
              (editingThumbnail.type === 'start' ||
                editingThumbnail.type === 'end')
            "
          >
            <v-col class="px-2">
              <span
                class="caption align-text"
                style="color: #f44336"
                v-html="$t('message.pages.video.errors.aboveMaxSizeThumbnail')"
              />
            </v-col>
          </v-row>
        </v-card> -->
        </v-col>
        <portal to="actions-footer">
          <div class="d-flex flex-row actions-row">
            <v-spacer></v-spacer>
            <v-tooltip max-width="184px" :disabled="unsavedChanges" top>
              <template v-slot:activator="{ on, attrs }">
                <div class="pl-2" v-bind="attrs" v-on="on">
                  <base-btn
                    @click="discardChanges"
                    v-if="hasEditVideoPerm"
                    :disabled="!unsavedChanges || loading"
                    type="tertiary"
                  >
                    {{ $t('message.actions.cancel') }}
                  </base-btn>
                </div>
              </template>
              <span>{{ $t('message.noChanges') }}</span>
            </v-tooltip>
            <v-tooltip max-width="184px" :disabled="unsavedChanges" top>
              <template v-slot:activator="{ on, attrs }">
                <div class="pl-2" v-bind="attrs" v-on="on">
                  <base-btn
                    @click="handleConfirmUpload"
                    :disabled="!unsavedChanges || loading"
                    :loading="loading"
                    v-if="hasEditVideoPerm"
                  >
                    {{ $t('message.actions.publish') }}
                  </base-btn>
                </div>
              </template>
              <span>{{ $t('message.noChanges') }}</span>
            </v-tooltip>
          </div>
        </portal>
      </div>
    </div>

    <v-dialog
      :fullscreen="isMobileBreakpoint"
      persistent
      v-model="openUploadStart"
      width="600px"
      height="600px"
    >
      <v-card
        v-if="!showPreviewImgStart"
        style="display: flex; justify-content: center; flex-direction: column"
      >
        <base-drop-zone
          :title="this.$i18next.t('message.pages.video.titleModalStart')"
          @close-upload="closeDialog"
          @file-uploaded="handleFileUploadStart"
          heightCard="340"
        />
        <v-card-text
          style="flex: 50%"
          class="mt-4 pb-0"
          v-if="filteredDefaultThumbsInfo.length"
        >
          <span class="body-label-caption neutral-60--text">
            {{ $t('message.pages.video.thumbnails.titleDefaultTitle') }}</span
          >
          <div
            style="
              display: flex;
              justify-content: space-between;
              width: 100%;
              align-items: center;
            "
          >
            <v-radio-group hide-details v-model="selectedDefaultStart">
              <v-radio
                v-for="(thumb, index) in filteredDefaultThumbsInfo"
                :key="thumb"
                :value="thumb"
                @change="isChangeThumb = true"
              >
                <template v-slot:label>
                  <div style="display: flex; align-items: center">
                    <previewThumbCard
                      style="
                        height: 32px !important;
                        width: 48px;
                        min-width: 48px !important;
                      "
                      :key="`defaultThumb_${index}`"
                      :loadingDelete="false"
                      :heightImage="'32px'"
                      :thumb="thumb"
                      :showCloseBtn="false"
                      :selected="false"
                      :showDownloadBtn="false"
                    />
                    <span class="body-regular-small neutral-20-dark-text">{{
                      `thumbnail_${index + 1}`
                    }}</span>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                gap: 16px;
              "
            >
              <div
                v-for="(thumb, index) in filteredDefaultThumbsInfo"
                :key="thumb"
              >
                <v-icon
                  @click="
                    handleDownloadThumb(thumb, `thumbnail_${index + 1}.jpg`)
                  "
                  class="subTitle-enable-thumb"
                  style="font-size: 16px"
                  >panda-download</v-icon
                >
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-text style="flex: 50%" class="mt-4 pb-0" v-else>
          <span class="body-label-caption neutral-60--text">
            {{ $t('message.pages.video.thumbnails.notGenerateThumbs') }}</span
          >
        </v-card-text>
        <v-divider class="mt-4"></v-divider>
        <v-card-actions>
          <v-row class="px-1 py-4">
            <v-col
              class="d-flex"
              :class="isMobileBreakpoint ? 'justify-center' : 'justify-end'"
            >
              <BaseBtn
                type="tertiary"
                class="mr-2"
                min-width="150"
                @click="closeDialog"
              >
                {{ $t('message.actions.cancel') }}
              </BaseBtn>
              <v-tooltip max-width="184px" :disabled="unsavedChanges" top>
                <template v-slot:activator="{ on, attrs }">
                  <BaseBtn
                    v-bind="attrs"
                    v-on="on"
                    :disabled="withoutChanges"
                    min-width="150"
                    @click="
                      handleDefaultThumbTemp(selectedDefaultStart)
                      closeDialog()
                    "
                    >{{ $t('message.actions.confirm') }}
                  </BaseBtn>
                </template>
                <span>{{ $t('message.noChanges') }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-toolbar class="ml-2" elevation="0">
          <v-toolbar-title class="text--subtitle">
            {{ $t('message.pages.video.titleModalStart') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="flex: 100%; padding-bottom: 24px">
          <div style="display: flex; justify-content: center">
            <div style="width: 300; margin-bottom: 24px">
              <v-img
                :src="defaultThumbnail"
                height="200"
                width="380"
                style="border-radius: 4px"
              >
              </v-img>
            </div>
          </div>
        </v-card-text>
        <v-divider class="mt-4"></v-divider>
        <v-card-actions>
          <v-row class="px-2">
            <v-col
              class="d-flex"
              :class="isMobileBreakpoint ? 'justify-center' : 'justify-end'"
            >
              <BaseBtn
                type="tertiary"
                class="mr-2"
                min-width="150"
                @click="closeDialog"
              >
                {{ $t('message.actions.close') }}
              </BaseBtn>
              <BaseBtn
                min-width="150"
                type="danger"
                @click="handleDeletePreviewThumbnailStart(defaultThumbnail)"
                >{{ $t('message.remove') }}
              </BaseBtn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      persistent
      :fullscreen="isMobileBreakpoint"
      v-model="openStartPreview"
      width="600px"
      height="600px"
    >
      <v-card>
        <v-toolbar class="ml-2" elevation="0">
          <v-toolbar-title class="text--subtitle">
            {{ $t('message.pages.video.titleModalStart') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialogPreview">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="flex: 100%; padding-bottom: 24px">
          <div style="display: flex; justify-content: center">
            <div style="width: 300; margin-bottom: 24px">
              <v-img
                :src="selectedDefaultStart"
                height="200"
                width="380"
                style="border-radius: 4px"
              >
              </v-img>
            </div>
          </div>
          <div class="d-flex" style="justify-content: space-between">
            <div style="display: grid; align-content: center">
              <span class="body-regular-small title-enable-thumb">{{
                $t('message.pages.video.thumbnails.activeThumb')
              }}</span>
              <span class="body-regular-smaller subTitle-enable-thumb">{{
                $t('message.pages.video.thumbnails.subTitleActiveThumb')
              }}</span>
            </div>
            <div>
              <v-switch
                class="toggle-input"
                :label="$t('message.actions.active')"
                :disabled="
                  this.defaultTempStartThumbnail == this.selectedDefaultStart
                "
                v-model="activeThumbnail"
              >
              </v-switch>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobileBreakpoint"
      persistent
      v-model="openUploadPause"
      width="600px"
    >
      <base-drop-zone
        v-if="!showEditPauseThumbs"
        :title="$t('message.pages.video.titleModalPause')"
        @close-upload="closeDialog"
        @file-uploaded="handleFileUploadPause"
      />
      <v-card v-if="showEditPauseThumbs">
        <v-toolbar class="ml-2" elevation="0">
          <v-toolbar-title class="text--subtitle">
            {{ $t('message.pages.video.titleModalPause') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialogPause">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="flex: 100%">
          <div style="display: flex; justify-content: center">
            <div style="width: 300">
              <div
                :style="{
                  ...changePlacementBtnThumbPreview(selectedPauseThumb),
                  background: `url(${selectedPauseThumb.metadata.fileUrl})`,
                  height: isVertical ? '300px' : '200px',
                  width: isVertical ? '170px' : '380px',
                }"
                class="preview-image"
              >
                <base-btn
                  :size="buttonSize(selectedPauseThumb)"
                  v-if="
                    selectedPauseThumb.metadata.thumb.hasButton && buttonSize
                  "
                  :style="{
                    color: buttonTextColor,
                    backgroundColor: buttonBackgroundColor,
                  }"
                  @mouseenter="applyHover"
                  @mouseleave="removeHover"
                >
                  {{ selectedPauseThumb.metadata.button.title }}
                </base-btn>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-text style="height: 350px; overflow: auto; padding-top: 24px">
          <v-row no-gutters v-if="selectedPauseThumb.metadata">
            <v-col cols="12">
              <v-input
                :label="$t('message.name')"
                v-model="selectedPauseThumb.metadata.thumb.title"
                :maxLength="40"
                :counter="showCounter ? 40 : null"
                @focus="showCounter = true"
                @blur="showCounter = false"
                dense
                :rules="[pauseThumbValidations.name]"
                :placeholder="$t('message.pages.video.thumbnails.thumbName')"
              ></v-input>
            </v-col>
            <v-col cols="12"><v-divider class="mb-4"></v-divider></v-col>
            <v-col cols="12"
              ><span class="body-bold-base neutral-20-dark-text">{{
                $t('message.pages.video.display')
              }}</span></v-col
            >
            <v-col cols="12" class="mt-4">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div style="display: grid">
                    <span class="neutral-20-dark-text">{{
                      $t('message.pages.videoPlayerButtons.lastAllVideo')
                    }}</span>
                    <span class="body-regular-smaller subTitle-enable-thumb">{{
                      $t('message.pages.videoPlayerButtons.lastAllVideoSub')
                    }}</span>
                  </div>
                  <v-switch
                    v-if="pauseThumbnails.length < 2"
                    v-model="selectedPauseThumb.metadata.thumb.lastAllVideo"
                    color="primary"
                    class="ma-0 toggle-input"
                    hide-details
                    @change="handleLastAllVideo"
                  ></v-switch>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-switch
                          disabled
                          color="primary"
                          class="ma-0 toggle-input"
                          hide-details
                          @change="handleLastAllVideo"
                        ></v-switch>
                      </div>
                    </template>
                    <span>{{
                      $t('message.pages.video.thumbnails.alreadyThumbnails')
                    }}</span>
                  </v-tooltip>
                </v-row>
              </v-col>
            </v-col>

            <v-col cols="12" class="mt-4">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div style="display: grid">
                    <span class="neutral-20-dark-text">{{
                      $t('message.pages.videoPlayerButtons.chooseTimeVideo')
                    }}</span>
                    <span class="body-regular-smaller subTitle-enable-thumb">{{
                      $t('message.pages.videoPlayerButtons.chooseTimeVideoSub')
                    }}</span>
                  </div>
                  <v-switch
                    v-model="showAllPause"
                    :value="showAllPause"
                    color="primary"
                    class="ma-0 toggle-input"
                    hide-details
                    @change="toggleLastAllVideoState"
                  ></v-switch>
                </v-row>
              </v-col>
            </v-col>

            <v-col
              v-if="!selectedPauseThumb.metadata.thumb.lastAllVideo"
              cols="12"
              class="mt-4 mb-1"
            >
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text">
                    {{ $t('message.pages.videoPlayerButtons.start') }} ({{
                      timePickerFormat
                    }})
                  </span>
                  <!-- start -->
                  <AntTimePicker
                    v-if="checkIfIsBetweenInterval"
                    class="hide-icon-time-picker error-timer"
                    :style="{ width: timeVideo >= 3600 ? '70px' : '' }"
                    :key="timePickerRenderKeys.start"
                    :startVal="
                      formatSecondsToTime(selectedPauseThumb.startTime)
                    "
                    :timeVideo="timeVideo"
                    :currentVal="
                      formatSecondsToTime(selectedPauseThumb.startTime)
                    "
                    :disabled="selectedPauseThumb.metadata.thumb.lastAllVideo"
                    @changedTime="handleStartTimeEvent"
                  />
                  <AntTimePicker
                    v-else
                    class="hide-icon-time-picker"
                    :style="{ width: timeVideo >= 3600 ? '70px' : '' }"
                    :key="`${timePickerRenderKeys.start}-else`"
                    :startVal="
                      formatSecondsToTime(selectedPauseThumb.startTime)
                    "
                    :timeVideo="timeVideo"
                    :currentVal="
                      formatSecondsToTime(selectedPauseThumb.startTime)
                    "
                    :disabled="selectedPauseThumb.metadata.thumb.lastAllVideo"
                    @changedTime="handleStartTimeEvent"
                  />
                </v-row>

                <v-row
                  class="mt-4"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text"
                    >{{ $t('message.pages.pauseThumbnail.end') }} ({{
                      timePickerFormat
                    }})</span
                  >
                  <AntTimePicker
                    v-if="checkIfIsBetweenInterval"
                    class="hide-icon-time-picker error-timer mt-2"
                    :key="timePickerRenderKeys.end"
                    :style="{ width: timeVideo >= 3600 ? '70px' : '' }"
                    :startVal="
                      isLowerOrEqual
                        ? formatSecondsToTime(selectedPauseThumb.startTime)
                        : formatSecondsToTime(selectedPauseThumb.endTime)
                    "
                    :thresholdTime="
                      formatSecondsToTime(selectedPauseThumb.startTime)
                    "
                    :timeVideo="timeVideo"
                    :currentVal="
                      formatSecondsToTime(selectedPauseThumb.endTime)
                    "
                    :disabled="
                      selectedPauseThumb.metadata.thumb.lastAllVideo ||
                      selectedPauseThumb.metadata.thumb.lastTillEnd
                    "
                    @changedTime="handleEndTimeEvent"
                  />
                  <AntTimePicker
                    v-else
                    class="hide-icon-time-picker mt-2"
                    :key="`${timePickerRenderKeys.end}-else`"
                    :style="{ width: timeVideo >= 3600 ? '70px' : '' }"
                    :startVal="
                      isLowerOrEqual
                        ? formatSecondsToTime(selectedPauseThumb.startTime)
                        : formatSecondsToTime(selectedPauseThumb.endTime)
                    "
                    :thresholdTime="
                      formatSecondsToTime(selectedPauseThumb.startTime)
                    "
                    :timeVideo="timeVideo"
                    :currentVal="
                      formatSecondsToTime(selectedPauseThumb.endTime)
                    "
                    :disabled="
                      selectedPauseThumb.metadata.thumb.lastAllVideo ||
                      selectedPauseThumb.metadata.thumb.lastTillEnd
                    "
                    @changedTime="handleEndTimeEvent"
                  />
                </v-row>
              </v-col>
            </v-col>
            <v-col
              v-if="
                checkIfIsBetweenInterval &&
                !selectedPauseThumb.metadata.thumb.lastAllVideo
              "
              cols="12"
            >
              <span
                class="red--text caption align-text align-end"
                style="display: flex; justify-content: flex-end"
              >
                {{ $t('message.pages.pauseThumbnail.alreadyExistsInThisTime') }}
              </span>
            </v-col>
            <v-col
              cols="12"
              class="mt-4"
              v-if="!selectedPauseThumb.metadata.thumb.lastAllVideo"
            >
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text">{{
                    $t('message.pages.videoPlayerButtons.lastTillEnd')
                  }}</span>
                  <v-switch
                    v-model="selectedPauseThumb.metadata.thumb.lastTillEnd"
                    dense
                    class="ma-0 toggle-input"
                    color="primary"
                    hide-details
                    @change="handleLastTillEnd"
                  ></v-switch>
                </v-row>
              </v-col>
            </v-col>
          </v-row>
          <v-divider class="my-4"></v-divider>
          <span class="body-bold-base neutral-20-dark-text">{{
            $t('message.pages.video.btnAction')
          }}</span>
          <v-col class="mt-4">
            <v-row
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <span class="h6 neutral-20-dark-text">{{
                $t('message.pages.videoPlayerButtons.addBtn')
              }}</span>
              <v-switch
                v-model="selectedPauseThumb.metadata.thumb.hasButton"
                hide-details
                class="ma-0 toggle-input"
                @change="() => handlePlayerPreviewPauseThumb()"
              ></v-switch>
            </v-row>
          </v-col>
          <video-player-buttons-thumbnail
            v-if="selectedPauseThumb.metadata.thumb.hasButton"
            :isThumbButton="true"
            :handleBack="handleBack"
            :newLayout="true"
            :hasEdit="[]"
          />
        </v-card-text>
        <v-divider class="mb-6 mt-4"></v-divider>
        <v-card-text class="mb-2">
          <v-row class="px-2" v-if="showEditPauseThumbs">
            <v-col
              class="d-flex"
              :class="isMobileBreakpoint ? 'justify-center' : 'justify-end'"
            >
              <BaseBtn
                type="tertiary"
                class="mr-2"
                min-width="150"
                :disabled="isEmpty(originalSelectedPauseThumb)"
                @click="handleDiscardPauseThumb"
              >
                {{ $t('message.actions.cancel') }}
              </BaseBtn>
              <BaseBtn
                min-width="150"
                :disabled="cantUploadPauseThumb || loadingPauseThumbnail"
                :loading="loadingPauseThumbnail"
                @click="
                  openUploadPause = false
                  loading = true
                  handlePublishPauseThumbnail()
                "
                >{{ $t('message.pages.videoPlayerButtons.publish') }}
              </BaseBtn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobileBreakpoint"
      persistent
      v-model="openUploadEnd"
      width="600px"
      height="600px"
    >
      <base-drop-zone
        v-if="!showPreviewImgEnd"
        :title="this.$i18next.t('message.pages.video.titleModalEnd')"
        @close-upload="closeDialog"
        @file-uploaded="handleFileUploadEnd"
        heightDropzone="100%"
      />
      <v-card v-else style="display: flex; flex-direction: column">
        <v-toolbar class="ml-2" style="flex: 0" elevation="0">
          <v-toolbar-title class="text--subtitle">
            {{ $t('message.pages.video.titleModalEnd') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="flex: 1; padding-bottom: 24px">
          <div style="display: flex; justify-content: center">
            <div style="width: 300; margin-bottom: 24px">
              <v-img
                :src="defaultEndThumbnail"
                height="200"
                width="380"
                style="border-radius: 4px"
              >
              </v-img>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row class="px-2">
            <v-col
              class="d-flex"
              :class="isMobileBreakpoint ? 'justify-center' : 'justify-end'"
            >
              <BaseBtn
                type="tertiary"
                class="mr-2"
                min-width="150"
                @click="closeDialog"
              >
                {{ $t('message.actions.close') }}
              </BaseBtn>
              <BaseBtn
                min-width="150"
                type="danger"
                @click="handleDeleteEndThumbnail(defaultEndThumbnail)"
                >{{ $t('message.remove') }}
              </BaseBtn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
/* eslint-disable */

// external imports
import download from 'downloadjs'
import { v4 as uuidv4 } from 'uuid'
import { mapActions, mapMutations, mapState } from 'vuex'
import _ from 'lodash'

// internal imports
import { THUMB_URL } from '@/config/envs.js'
import linkHelper from '@/utils/linkHelper.mixin.js'

// API
import videosApi from '@/services/videosApi'
import playerApi from '@/services/playerApi'

// Components
import BaseActionList from '@/components/BaseActionList'
import VideoPlayerButtons from './VideoPlayerButtons.vue'
import LearnMoreBtn from '@/components/LearnMoreBtn.vue'
import AntTimePicker from '@/components/AntTimePicker.vue'
import sendThumbCard from '@/components/sendThumbCard.vue'
import previewThumbCard from '@/components/previewThumbCard.vue'
import BaseBtn from '@/components/BaseBtn.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import BaseDropZone from '../../../components/BaseDropZone.vue'
import VideoPlayerButtonsThumbnail from './VideoPlayerButtonsThumbnail.vue'
import imagePlaceholder from '@/assets/placeholder-image.png'
export default {
  name: 'VideoPlayerThumbnails',
  components: {
    VideoPlayerButtonsThumbnail,
    LearnMoreBtn,
    AntTimePicker,
    sendThumbCard,
    previewThumbCard,
    BaseBtn,
    BaseAlert,
    BaseDropZone,
    BaseActionList,
  },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    liveVideoId: {
      required: false,
    },
  },
  mixins: [linkHelper],
  data: () => ({
    smartAutoPlay: false,
    videoId: '',
    imagePlaceholder,
    newThumbnail: {
      file: null,
    },
    renderTick: 0,
    newPauseThumbnail: {
      file: null,
    },
    newEndThumbnail: {
      file: null,
    },
    showCounter: false,
    showEditPauseThumbs: false,
    loading: false,
    buttonBackgroundColor: '',
    placementPreviewBtn: {},
    loadingRemoveDefault: false,
    loadingRemoveEnd: false,
    openStartPreview: false,
    buttonTextColor: '',
    unsavedChanges: false,
    selectedDefaultStart: '',
    activeThumbnail: true,
    showAllPause: false,
    showPreviewImgStart: false,
    showPreviewImgEnd: false,
    openUploadStart: false,
    openUploadPause: false,
    openUploadEnd: false,
    isEditingPauseThumb: false,
    defaultTempStartThumbnail: null,
    loadingPauseThumbnail: false,
    loadingEndThumbnail: false,
    loadingDeleteThumb: false,
    loadingDeletePauseThumb: false,
    loadingDeleteEndThumb: false,
    successfulChangedThumb: false,
    successfulChangedPauseThumb: false,
    successfulChangedEndThumb: false,
    successfulDeleteThumb: false,
    successfulDeletePauseThumb: false,
    successfulDeleteEndThumb: false,
    isChangeThumb: false,
    loadingSlider: true,
    errors: {
      addThumbnail: false,
      wrongThumbnailFile: false,
      updateThumbnailVideo: false,
      updateThumbnailPauseVideo: false,
      updateThumbnailEndVideo: false,
      thumbAboveMaxSize: false,
    },
    defaultThumbnail: null,
    defaultPauseThumbnail: null,
    defaultEndThumbnail: null,
    arrayCtas: [],
    havePauseThumb: false,
    haveEndThumb: false,
    activeSkipButton: true,
    loadingSkipButton: false,
    isEditingThumb: false,
    editingThumbnail: {
      title: '',
      startTime: '00:00',
      endTime: '00:05',
      hasButton: false,
      type: 'start',
      lastTillEnd: false,
      lastAllVideo: false,
    },
    selectedPauseThumb: {},
    timeVideo: null,
    scrollInvoked: 0,
    pauseThumbnails: [],
    originalPauseThumbnailsList: [],
    beingEditedPauseThumb: {},
    isThumbUpdate: false,
    beingDeletePauseThumbId: '',
    previewImg: null,
    popupStartTime: true,
    popupEndTime: true,
    defaultThumbsInfo: {},
    pauseThumbValidations: {
      name: (value) => {
        if (value.length) return true
        return false
      },
    },
  }),
  async mounted() {
    this.loadingSlider = true
    try {
      this.defaultThumbnail = this.$store.state.video.video?.thumbnail
      this.defaultTempStartThumbnail = this.defaultThumbnail
      this.selectedDefaultStart = this.defaultThumbnail
      this.formatVideoLength()
      await this.getVideoDefaultThumbs()
      this.videoId = this.liveVideoId ?? this.$route.params.id
      this.arrayCtas = this.$store.state.video.video.config?.ctas ?? []
      this.smartAutoPlay = this.$store.state.video.profile?.vsl?.autoplay
      this.defaultThumbnail = this.$store.state.video.video?.thumbnail
      if (this.$store.state.video.video?.endThumbnail) {
        this.defaultEndThumbnail = this.$store.state.video.video?.endThumbnail
      } else {
        const existsEndCta = this.arrayCtas.find((item) => item.type === 'end')
        if (existsEndCta) {
          if (existsEndCta.metadata && existsEndCta.metadata.fileUrl) {
            this.defaultEndThumbnail = existsEndCta.metadata.fileUrl
          } else {
            // get thumb url from img tag src
            try {
              const imgUrl = existsEndCta.script.match(/src='([^']*)'/)[1]
              if (imgUrl) {
                this.defaultEndThumbnail = imgUrl
              }
            } catch (error) {
              console.log('failed to get end thumb from cta')
            }
          }
        }
      }

      let pauseThumbs = this.arrayCtas.filter((item) => item.type === 'pause')
      let mappedPauseThumbs = pauseThumbs.map((item) => {
        if (item.metadata) return item
        else {
          let thumbFilename =
            this.$store.state.video.video?.config.pauseThumbnail

          return {
            ...item,
            metadata: {
              thumb: {
                ...this.editingThumbnail,
                title: 'Thumb',
                type: 'pause',
                hasButton: false,
              },
              fileUrl: this.$store.state.video.video?.pauseThumbnail,
              thumbId: thumbFilename,
            },
            startTime: 0,
            endTime: this.$store.state.video.video?.length,
          }
        }
      })

      this.pauseThumbnails = mappedPauseThumbs
      this.originalPauseThumbnailsList = _.cloneDeep(this.pauseThumbnails)

      this.selectedPauseThumb = this.getDefaultPauseThumbObj()

      this.$root.$on('setCtas', (value) => {
        this.selectedPauseThumb.metadata.button = value[0].metadata || {}
        this.buttonBackgroundColor = value[0]?.metadata.backgroundColor
        this.buttonTextColor = value[0]?.metadata.textColor
        this.renderTick += 1
      })
      this.$root.$on('buttonsFormInfo', (createdBtnInfo) => {
        this.selectedPauseThumb.metadata.button = createdBtnInfo.buttonMetadata
        this.selectedPauseThumb.metadata.thumb.hasButton = true
        this.handleUploadPauseThumbnail(createdBtnInfo)
      })
      this.loadingSlider = false
    } catch (err) {
      console.log(err)
      this.loadingSlider = false
    }
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      profile_id: (state) => state.video.profile_id,
      internalError: (state) => state.video.internalError,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    isVertical() {
      return this.video.height > this.video.width
    },

    filteredDefaultThumbsInfo() {
      if (this.defaultThumbsInfo?.default)
        return this.defaultThumbsInfo.default.filter(
          (thumb) => !thumb.includes('thumbnail_3')
        )
      return []
    },
    defaultBtn() {
      return {
        title: this.$i18next.t('message.pages.video.buttonDefaultText'),
        link: '',
        startTime: '00:00',
        endTime: '00:05',
        selectedButtonType: 'insideVideo',
        textColor: '#FFFFFF',
        textHover: '#FFFFFF',
        backgroundColor: '#3e50f7',
        backgroundHover: '#3e50f7',
        selectedButtonSize: 'small',
        selectedButtonPlacement: 'midCenter',
        isCustomHtml: false,
        codeHtml: '',
        lastAllVideo: false,
        lastTillEnd: false,
        keepWindow: false,
        appendWebsiteQueryParams: false,
      }
    },
    timePickerRenderKeys: {
      get() {
        const ret = {
          start: `start__${this.selectedPauseThumb.id}-${this.renderTick}`,
          end: `end__${this.selectedPauseThumb.id}-${this.renderTick}`,
        }
        return ret
      },
      deep: true,
      cache: false,
    },
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
    colorDisable() {
      if (this.$vuetify.theme.dark) return { color: '#666D99 !important' }
      return { color: '#ABADBA !important' }
    },
    timePickerFormat() {
      if (this.timeVideo >= 3600) {
        return 'hh:mm:ss'
      }
      return 'mm:ss'
    },
    isBunnyThumbnail() {
      return this.defaultThumbnail
        ? this.defaultThumbnail.includes('thumbnail')
        : false
    },
    originalSelectedPauseThumb() {
      const originalObj = this.originalPauseThumbnailsList.filter(
        (item) => item.id === this.selectedPauseThumb.id
      )
      if (originalObj.length) return { ...originalObj[0] }
      return {}
    },
    withoutChanges() {
      return this.selectedDefaultStart == this.defaultThumbnail
    },
    cantUploadPauseThumb: {
      get() {
        const selectedPauseThumb = { ...this.selectedPauseThumb }
        if (!selectedPauseThumb.metadata?.fileUrl) {
          return true
        }
        if (
          (this.originalSelectedPauseThumb &&
            _.isEqual(selectedPauseThumb, this.originalSelectedPauseThumb)) ||
          !selectedPauseThumb.metadata.thumb.title
        ) {
          return true
        }

        if (
          (!selectedPauseThumb.metadata?.button?.link &&
            selectedPauseThumb.metadata?.thumb?.hasButton) ||
          (!selectedPauseThumb.metadata?.button?.title &&
            selectedPauseThumb.metadata?.thumb?.hasButton)
        )
          return true
        return (
          this.loadingPauseThumbnail ||
          this.checkIfIsBetweenInterval ||
          this.checkDomainRegex(selectedPauseThumb)
        )
      },
      cache: false,
      deep: true,
    },
    checkIfIsBetweenInterval: {
      get() {
        if (
          !this.selectedPauseThumb.startTime &&
          this.selectedPauseThumb.startTime !== 0
        )
          return false
        let hasNewThumbCreated = false
        let x = this.pauseThumbnails.map((el) => {
          if (el.id === this.selectedPauseThumb.id)
            return { start: -1, end: -1 }
          if (!hasNewThumbCreated && (el.startTime || el.endTime)) {
            hasNewThumbCreated = true
          }
          return {
            start: el.startTime,
            end: el.endTime,
          }
        })
        let result = []
        let z = {
          start: this.selectedPauseThumb.startTime,
          end: this.selectedPauseThumb.endTime,
        }
        if (hasNewThumbCreated) {
          result = x.filter(
            (i) =>
              this.inRange(z.start, i.start, i.end) ||
              this.inRange(z.end, i.start, i.end)
          )
        } else {
          result = x.filter(
            (i) =>
              this.inRange(z.start, i.start, i.end) ||
              this.inRange(z.end, i.start, i.end)
          )
        }
        return !!result.length
      },
      deep: true,
      cache: false,
    },
    isLowerOrEqual() {
      const { endTime, startTime } = this.selectedPauseThumb
      return endTime < startTime
    },
  },
  watch: {
    successfulChangedThumb() {
      if (this.successfulChangedThumb) {
        setTimeout(() => {
          this.successfulChangedThumb = false
        }, 20000)
      }
    },
    editingButton() {},
  },
  methods: {
    ...mapActions('video', [
      'updateCta',
      'getVideoConfig',
      'createProfile',
      'setProfileToVideos',
      ,
    ]),
    ...mapMutations('video', [
      'UPDATE_VIDEO',
      'UPDATE_STATUS_ERROR',
      'UPDATE_VIDEO_CONFIG_CTAS',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    async handleFileUploadStart(file) {
      this.isChangeThumb = false
      this.newThumbnail.file = file
      const imageBase64 = await this.toBase64(this.newThumbnail.file)

      this.defaultThumbnail = imageBase64
      this.handleDefaultThumbTemp(this.defaultThumbnail)
      const text = this.$i18next.t('message.pages.video.thumbnails.addMsgThumb')
      this.closeDialog()
      this.UPDATE_GLOBAL_SNACKBAR({ open: true, text, type: 'success' })
      this.unsavedChanges = true
    },
    closeDialogPause() {
      if (this.isEditingPauseThumb) {
        this.handleDiscardPauseThumb()
        this.closeDialog()
        return
      }
      const index = this.pauseThumbnails.findIndex(
        (thumb) => thumb == this.selectedPauseThumb
      )
      this.handleRemoveThumb(this.selectedPauseThumb, index)
      this.showEditPauseThumbs = false
      this.openUploadPause = false
      this.isEditingPauseThumb = false
      this.selectedPauseThumb = this.getDefaultPauseThumbObj()
    },
    handleDefaultThumbTemp(defaultTempStartThumbnail) {
      this.defaultTempStartThumbnail = defaultTempStartThumbnail
      this.unsavedChanges = true
    },
    handleFileUploadPause(file) {
      this.newPauseThumbnail.file = file
      this.showPreviewImg()
      this.showEditPauseThumbs = true
      if (this.pauseThumbnails.length > 0) {
        this.showAllPause = true
        this.selectedPauseThumb.metadata.thumb.lastAllVideo = false
      } else {
        this.showAllPause = false
        this.selectedPauseThumb.metadata.thumb.lastAllVideo = true
      }
      this.selectedPauseThumb.endTime = this.timeVideo
    },
    async handleFileUploadEnd(file) {
      this.newEndThumbnail.file = file

      const imageBase64 = await this.toBase64(this.newEndThumbnail.file)
      this.defaultEndThumbnail = imageBase64
      this.unsavedChanges = true
      const text = this.$i18next.t('message.pages.video.thumbnails.addMsgThumb')
      this.closeDialog()
      this.UPDATE_GLOBAL_SNACKBAR({ open: true, text, type: 'success' })
    },
    closeDialog() {
      this.openUploadStart = false
      this.openUploadPause = false
      this.openUploadEnd = false
      this.showPreviewImgStart = false
      this.showEditPauseThumbs = false
      this.showPreviewImgEnd = false
      this.isEditingPauseThumb = false
      this.selectedPauseThumb = this.getDefaultPauseThumbObj()
    },
    handleDeletePreviewThumbnailStart(selectedDefaultStart) {
      this.handleDeleteThumbnail('removeButton')
      this.showPreviewImgStart = false
    },
    closeDialogPreview() {
      if (this.activeThumbnail) {
        this.defaultTempStartThumbnail = this.selectedDefaultStart
        this.unsavedChanges = true
      }
      this.openStartPreview = false
      this.activeThumbnail = true
    },
    triggerClick(refName) {
      const refElement = this.$refs[refName]
      if (refElement && refElement.$el) {
        const inputElement = refElement.$el.querySelector('input[type="file"]')
        if (inputElement) {
          inputElement.click()
        }
      }
    },
    getFileNameFromUrl(url) {
      if (!url) return ''
      return url
    },

    handleDownloadThumb(thumbUrl, name) {
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = thumbUrl
      img.onload = () => {
        const canvas = new OffscreenCanvas(img.width, img.height)
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)

        canvas
          .convertToBlob()
          .then((blob) => {
            if (!blob) {
              this.loadings.removingCta = false
              return
            }

            let filename = thumbUrl.split('/').pop()
            filename = name || filename

            download(blob, filename)
          })
          .finally(() => {})
      }
      img.onerror = () => {
        console.warn('Erro de CORS ao carregar a imagem, abrindo em nova aba.')
        window.open(thumbUrl, '_blank')
      }
    },
    selectedPauseThumbnails(selectedPauseThumb) {
      this.selectedPauseThumb = selectedPauseThumb
      this.showAllPause = !this.selectedPauseThumb.metadata.thumb.lastAllVideo
      this.handlePlayerPreviewPauseThumb()
      this.checkIfSelectedPauseThumbHasButton()
      this.isEditingPauseThumb = true
      this.showEditPauseThumbs = true
      this.buttonBackgroundColor = (
        this.selectedPauseThumb.metadata.button || {}
      ).backgroundColor
      this.buttonTextColor = (
        this.selectedPauseThumb.metadata.button || {}
      ).textColor
      this.openUploadPause = true
    },
    async getVideoDefaultThumbs() {
      const ret = await videosApi.getThumbs(this.video.id)
      this.defaultThumbsInfo = ret.data.response || {}
    },
    async handleUpdateDefaultThumb(defaultThumb) {
      this.loadingDeleteThumb = true
      if (!this.isBunnyThumbnail) {
        await this.handleDeleteThumbnail(false, true)
      }
      await playerApi.updateVideoCurrentThumb({
        video_id: this.video.id,
        thumb: defaultThumb,
      })
      this.defaultThumbnail = defaultThumb
      this.defaultTempStartThumbnail = defaultThumb
      await this.getVideoConfig(this.videoId)
      this.loadingDeleteThumb = false
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async handleConfirmUpload() {
      this.loading = true
      this.loadingRemoveEnd = true
      this.loadingRemoveDefault = true
      if (this.isChangeThumb)
        await this.handleUpdateDefaultThumb(this.defaultTempStartThumbnail)
      else await this.handleChangeThumbnail()
      await this.handleUploadEndThumbnail()
      this.defaultTempStartThumbnail = this.defaultThumbnail
      this.loading = false
      this.loadingRemoveEnd = false
      this.loadingRemoveDefault = false
      this.unsavedChanges = false

      const text = this.$i18next.t('message.changesSaved')
      const open = true

      this.UPDATE_GLOBAL_SNACKBAR({ open, text })
    },
    checkIfSelectedPauseThumbHasButton() {
      if (
        this.selectedPauseThumb.metadata?.button &&
        Object.keys(this.selectedPauseThumb.metadata?.button).length &&
        !this.selectedPauseThumb.metadata.thumb?.hasButton
      ) {
        this.selectedPauseThumb.metadata.thumb.hasButton = true
      }
    },
    isEmpty(obj) {
      return _.isEmpty(obj)
    },
    async handleLoadPauseThumbBtn(timeout) {
      if (!this.selectedPauseThumb.metadata.button) {
        this.selectedPauseThumb.metadata.button = _.cloneDeep(this.defaultBtn)
        this.selectedPauseThumb.metadata.button.startTime =
          this.formatSecondsToTime(this.selectedPauseThumb.startTime)
        this.selectedPauseThumb.metadata.button.endTime =
          this.formatSecondsToTime(this.selectedPauseThumb.endTime)
      }
      let imageURL = this.selectedPauseThumb.metadata.fileUrl
      if (imageURL.includes('blob:')) {
        const imageBase64 = await this.toBase64(this.newPauseThumbnail.file)
        imageURL = imageBase64
      }

      setTimeout(() => {
        this.$root.$emit(
          'editPauseThumbButton',
          this.selectedPauseThumb.metadata.button,
          imageURL
        )
      }, timeout)
    },
    async handleLoadPauseThumbNoBtn() {
      delete this.selectedPauseThumb.metadata.button
      const hasImageAttached = Boolean(this.selectedPauseThumb.metadata.fileUrl)

      if (hasImageAttached) {
        let imageURL = this.selectedPauseThumb.metadata.fileUrl
        if (imageURL.includes('blob:')) {
          const imageBase64 = await this.toBase64(this.newPauseThumbnail.file)
          imageURL = imageBase64
        }
        const cta = this.generateThumbCta(imageURL, 'pauseThumbnail')
        this.handlePostMessageCtas([cta])
      } else {
        this.handleEmptyIframeCtas()
      }
    },
    async handlePlayerPreviewPauseThumb(timeout = 300) {
      const hasValidThumbBtn = this.selectedPauseThumb.metadata.thumb.hasButton
      if (hasValidThumbBtn) {
        this.handleLoadPauseThumbBtn(timeout)
      } else {
        this.handleLoadPauseThumbNoBtn()
      }
    },
    handleOpenThumbLink() {
      window.open(this.getPauseThumbnailLink(), '_blank')
    },
    handleEmptyIframeCtas() {
      this.handlePostMessageCtas([])
    },
    handlePostMessageCtas(ctas) {
      if (this.video.hasOwnProperty('video_source')) {
        this.$root.$emit('setCtas', ctas)
      } else {
        const iframe = document.getElementById('panda-player').contentWindow
        iframe.postMessage(
          {
            type: 'ctas',
            parameter: {
              ctas,
            },
          },
          '*'
        )
      }
    },
    inRange(x, min, max) {
      return (x - min) * (x - max) <= 0
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
      })
    },
    async showPreviewImg() {
      if (!this.newPauseThumbnail?.file) return
      const imageBase64 = await this.toBase64(this.newPauseThumbnail.file)
      const previewUrl = imageBase64
      this.previewImg = previewUrl
      if (!this.pauseThumbnails.length) {
        this.selectedPauseThumb.metadata.fileUrl = previewUrl
        this.selectedPauseThumb.metadata.thumb.title = `thumbnail_pause_0`
        this.pauseThumbnails.push(this.selectedPauseThumb)
      } else {
        const defaultObj = this.getDefaultPauseThumbObj()
        defaultObj.metadata.fileUrl = previewUrl
        defaultObj.endTime = 5
        defaultObj.metadata.thumb.title = `thumbnail_pause_${this.pauseThumbnails.length}`
        this.pauseThumbnails.push(defaultObj)
        this.selectedPauseThumb = defaultObj
        this.checkIfSelectedPauseThumbHasButton()
      }
      this.handlePlayerPreviewPauseThumb()
    },
    handlePublishPauseThumbnail() {
      setTimeout(() => {
        if (this.selectedPauseThumb.metadata.thumb.hasButton) {
          this.$root.$emit('getPauseThumbButton')
        } else {
          this.handleUploadPauseThumbnail()
        }
      }, 300)
      this.$root.$emit('updateEmbedPreviewChange')
    },
    handleDiscardPauseThumb() {
      const pauseThumbsListIndex = this.pauseThumbnails.findIndex(
        (item) => item.id === this.selectedPauseThumb.id
      )
      if (pauseThumbsListIndex !== -1) {
        this.pauseThumbnails.splice(
          pauseThumbsListIndex,
          1,
          _.cloneDeep(this.originalSelectedPauseThumb)
        )
      }
      this.pauseThumbnails = _.cloneDeep(this.originalPauseThumbnailsList)
      this.selectedPauseThumb = _.cloneDeep(this.originalSelectedPauseThumb)
      this.showAllPause = !this.selectedPauseThumb.metadata.thumb.lastAllVideo
      this.checkIfSelectedPauseThumbHasButton()
      this.handlePlayerPreviewPauseThumb(0)
      this.closeDialog()
      this.$root.$emit('updateEmbedPreviewChange')
    },
    onScroll() {
      this.scrollInvoked++
    },
    handleBackFromThumbForm() {
      this.previewImg = null
      this.isEditingThumb = false
    },
    resetForm() {
      this.defaultPauseThumbnail = ''
      this.editingThumbnail = {
        title: '',
        startTime: '00:00',
        endTime: '00:05',
        hasButton: false,
        type: 'pause',
      }
      this.previewImg = null
      this.isThumbUpdate = false
      this.newPauseThumbnail.file = null
    },
    handleEditThumb(thumbnailCta) {
      this.resetForm()
      this.isThumbUpdate = false
      if (thumbnailCta?.id) {
        if (thumbnailCta.metadata.thumb) {
          this.editingThumbnail = thumbnailCta.metadata.thumb
          this.editingThumbnail.startTime = thumbnailCta.startTime
          this.editingThumbnail.endTime = thumbnailCta.endTime
        }
        this.defaultPauseThumbnail = thumbnailCta.metadata.fileUrl
        this.beingEditedPauseThumb = thumbnailCta
        this.isThumbUpdate = true
      }
      this.isEditingThumb = true
      if (thumbnailCta?.metadata?.button) {
        setTimeout(() => {
          this.$root.$emit('editPauseThumbButton', thumbnailCta.metadata.button)
        }, 300)
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    handleChangeThumbType(type) {
      this.isEditingThumb = this.arrayCtas.length === 0
      this.editingThumbnail.type = type
    },
    async handleChangeThumbnail() {
      this.successfulDeleteThumb = false
      this.successfulChangedThumb = false
      this.clearErrors()
      const file = this.newThumbnail.file
      let fileExtension =
        file?.name?.substring(
          file?.name?.lastIndexOf('.') + 1,
          file?.name?.length
        ) || file?.name
      if (
        fileExtension !== 'jpg' &&
        fileExtension !== 'png' &&
        fileExtension !== 'jpeg' &&
        fileExtension !== 'gif'
      ) {
        this.errors.wrongThumbnailFile = true
        this.newThumbnail.file = null
        return
      }
      const data = new FormData()
      data.append('file', file)
      this.defaultThumbnail = this.getThumbsLink(file?.name)
      try {
        const ret = await videosApi.addThumbnailToVideo(this.videoId, data)
        await this.getVideoConfig(this.videoId)
        this.defaultThumbnail = `${process.env.VUE_APP_THUMB_API}/${this.video.pullzone_name}/${ret.data.response.thumb}`
        this.successfulChangedThumb = true
        this.$root.$emit('updateEmbedPreviewChange')
        return ret
      } catch (e) {
        if ((e.response && e.response.status === 413) || !e.response)
          this.errors.thumbAboveMaxSize = true
        this.errors.updateThumbnailVideo = true
      }
    },
    getPauseThumbUploadFormData() {
      if (this.selectedPauseThumb.metadata.hasOwnProperty('thumbId')) return
      const file = this.newPauseThumbnail.file
      if (file) {
        let fileExtension =
          file?.name?.substring(
            file?.name?.lastIndexOf('.') + 1,
            file?.name?.length
          ) || file?.name
        if (
          fileExtension !== 'jpg' &&
          fileExtension !== 'png' &&
          fileExtension !== 'jpeg' &&
          fileExtension !== 'gif'
        ) {
          this.errors.wrongThumbnailFile = true
          this.newPauseThumbnail.file = null
          return
        }
        let data = new FormData()
        data.append('file', file)
        this.$root.$emit('updateEmbedPreviewChange')
        return data
      }
      return
    },
    applyHover() {
      this.buttonBackgroundColor =
        this.selectedPauseThumb.metadata.button.backgroundHover

      this.buttonTextColor =
        this.selectedPauseThumb.metadata.button.textColorHover
    },
    removeHover() {
      this.buttonBackgroundColor =
        this.selectedPauseThumb.metadata.button.backgroundColor
      this.buttonTextColor = this.selectedPauseThumb.metadata.button.textColor
    },
    changePlacementBtnThumbPreview(placement) {
      const place = placement.metadata?.button?.selectedButtonPlacement
      const placementMap = {
        topLeft: { justifyContent: 'flex-start', alignItems: 'flex-start' },
        topCenter: { justifyContent: 'center', alignItems: 'flex-start' },
        topRight: { justifyContent: 'flex-end', alignItems: 'flex-start' },
        midLeft: { justifyContent: 'flex-start', alignItems: 'center' },
        midCenter: { justifyContent: 'center', alignItems: 'center' },
        midRight: { justifyContent: 'flex-end', alignItems: 'center' },
        bottomLeft: { justifyContent: 'flex-start', alignItems: 'flex-end' },
        bottomCenter: { justifyContent: 'center', alignItems: 'flex-end' },
        bottomRight: { justifyContent: 'flex-end', alignItems: 'flex-end' },
      }

      return (
        placementMap[place] || {
          justifyContent: 'center',
          alignItems: 'center',
        }
      )
    },
    buttonSize(selectedPauseThumb) {
      const size =
        selectedPauseThumb.metadata.button?.selectedButtonSize || 'medium'
      switch (size) {
        case 'small':
          return 'xsmall'
        case 'medium':
          return 'small'
        default:
          return 'default'
      }
    },
    async handleUploadPauseThumbnail(createdBtnInfo) {
      this.loading = true

      if (this.selectedPauseThumb.metadata.thumbId) {
        this.isThumbUpdate = true
      } else {
        this.isThumbUpdate = false
      }
      this.successfulDeleteThumb = false
      this.successfulChangedThumb = false
      this.clearErrors()

      const uploadFormData = this.getPauseThumbUploadFormData()
      if (this.errors.wrongThumbnailFile) {
        this.loadingPauseThumbnail = false
        this.loading = false
        return
      }
      this.loadingPauseThumbnail = true

      try {
        if (this.isThumbUpdate) {
          await this.handleDeletePauseThumbnail(
            this.selectedPauseThumb.id,
            this.selectedPauseThumb.metadata.thumbId,
            Boolean(uploadFormData),
            true
          )
        }

        let ret
        if (uploadFormData) {
          ret = await videosApi.addThumbnailToPauseVideo(
            this.videoId,
            uploadFormData
          )
        }
        let thumbFilename =
          ret?.data?.response?.pauseThumbnail[0] ||
          this.selectedPauseThumb.metadata.thumbId
        await this.handleUpdateConfigPauseThumbnail({
          ...createdBtnInfo,
          thumbFilename,
        })
        this.checkIfSelectedPauseThumbHasButton()
        this.handlePlayerPreviewPauseThumb()
        this.loading = false
        this.loadingPauseThumbnail = false
        this.successfulDeleteThumb = true
        const text = this.$i18next.t(
          'message.pages.videoEditModal.serverUpdateOnUpload'
        )

        this.UPDATE_GLOBAL_SNACKBAR({ open: true, text, type: 'success' })
        this.closeDialog()
      } catch (e) {
        this.loadingPauseThumbnail = false
        this.loading = false
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async handleUploadEndThumbnail() {
      this.successfulDeleteThumb = false
      this.successfulChangedThumb = false

      this.clearErrors()

      const { file } = this.newEndThumbnail

      let fileExtension =
        file?.name?.substring(
          file?.name?.lastIndexOf('.') + 1,
          file?.name?.length
        ) || file?.name

      if (!['jpg', 'png', 'jpeg', 'gif'].includes(fileExtension)) {
        this.errors.wrongThumbnailFile = true
        this.newEndThumbnail.file = null

        return
      }

      this.loadingEndThumbnail = true

      const data = new FormData()
      data.append('file', file)

      try {
        if (this.thumbnailHas('end')) {
          this.defaultEndThumbnail = null
          await this.handleDeleteEndThumbnail()
        }

        let ret = await videosApi.addThumbnailToEndVideo(this.videoId, data)
        let thumbName = ret.data.response.endThumbnail

        if (!this.thumbnailHas('end')) {
          this.UPDATE_VIDEO_CONFIG_CTAS(this.arrayCtas)

          this.UPDATE_STATUS_ERROR(false)

          this.loadPublishedCtas()
        }

        await this.handleUpdateConfigEndThumbnail(thumbName)
        this.handleSnackbar()
      } catch (e) {
        console.error(e)
        if ((e.response && e.response.status === 413) || !e.response)
          this.errors.thumbAboveMaxSize = true
        this.errors.updateThumbnailVideo = true
        this.loadingEndThumbnail = false
      }
      this.loadingEndThumbnail = false
      this.$root.$emit('updateEmbedPreviewChange')
    },
    getThumbsLink(thumb) {
      if (thumb.includes('/')) {
        thumb = thumb.split('/').slice(-1)
      }
      return `${THUMB_URL}/${this.$store.state.video.video?.pullzone_name}/${thumb}`
    },
    checkDomainRegex(selectedPauseThumb) {
      let link = selectedPauseThumb.metadata?.button?.link ?? ''
      if (!selectedPauseThumb.metadata?.thumb?.hasButton) return false
      if (link.length < 2) {
        return true
      }
      const pattern = new RegExp(
        /^(https?):\/\/([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/\S*)?$/
      )
      return !pattern.test(link)
    },
    async handleUpdateConfigPauseThumbnail(formInfo) {
      const currentPauseThumbnailLink = this.getThumbsLink(
        formInfo.thumbFilename
      )
      try {
        const cta = this.generateThumbCta(
          currentPauseThumbnailLink,
          'pauseThumbnail',
          formInfo
        )
        if (
          cta.metadata.thumb?.title == '' &&
          cta.metadata.thumb.hasButton == true
        )
          return
        const ret = await playerApi.addCta(this.videoId, cta)

        let pauseArray = ret.data.ctas.filter((item) => item.type === 'pause')
        let lastItem = pauseArray[pauseArray.length - 1]
        pauseArray.pop()
        pauseArray.unshift(lastItem)
        const draftPauseThubms = this.pauseThumbnails.filter(
          (item) =>
            !item.metadata.hasOwnProperty('thumbId') &&
            item.id !== this.selectedPauseThumb.id
        )
        this.pauseThumbnails = [...draftPauseThubms, ...pauseArray]
        this.selectedPauseThumb =
          this.pauseThumbnails.filter(({ id }) => id === cta.id)[0] ??
          this.getDefaultPauseThumbObj()
        this.originalPauseThumbnailsList = _.cloneDeep(pauseArray)
        this.arrayCtas = ret.data.ctas
        this.handleBackFromThumbForm()
        await this.getVideoConfig(this.videoId)
        this.UPDATE_VIDEO_CONFIG_CTAS(this.arrayCtas)
        if (!this.internalError) {
          this.withoutChanges = true
          this.loadingPauseThumbnail = false
          this.defaultPauseThumbnail =
            this.$store.state.video.video?.pauseThumbnail
          this.successfulChangedThumb = true
          this.loadPublishedCtas()
          this.loadingSkipButton = false
          this.handleSnackbar()
        }
      } catch (e) {
        console.error(e)
        this.loadingButtonSave = false
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async handleUpdateConfigEndThumbnail(thumbName) {
      const endThumbnailLink = this.getThumbsLink(thumbName)

      try {
        const cta = await this.generateThumbCta(
          endThumbnailLink,
          'endThumbnail',
          null
        )
        const ret = await playerApi.addCta(this.videoId, cta)

        this.arrayCtas = ret.data.ctas
        this.UPDATE_VIDEO_CONFIG_CTAS(this.arrayCtas)

        if (this.internalError) {
          this.withoutChanges = true
          this.loadingEndThumbnail = false
          this.successfulChangedThumb = true

          this.loadingSkipButton = false

          this.handleSnackbar()
        }

        this.loadPublishedCtas()
      } catch (e) {
        console.error(e)
        this.loadingButtonSave = false
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    generateThumbCta(thumbnail, type, formInfo) {
      let codeThumbnail
      let ctaScript
      if (type === 'pauseThumbnail') {
        if (this.selectedPauseThumb.metadata.thumb.hasButton) {
          ctaScript = formInfo.script
          const base64Index = ctaScript.indexOf(
            `background-image: url('data:image`
          )
          if (base64Index >= 0) {
            const base64Content = ctaScript
              .split(`background-image: url('`)[1]
              .split(`')`)[0]
            ctaScript = ctaScript.replace(base64Content, thumbnail)
          }
        } else {
          ctaScript =
            `<img src='${thumbnail}' style='object-fit:cover; width:100%; height:100%;'><script>document.querySelector('img').onclick=function() { window.parent.postMessage({type: 'cta_play',}, '*') }</scr` +
            `ipt>`
        }
      }
      if (type === 'pauseThumbnail') {
        codeThumbnail = thumbnail
          ? {
              id: this.generateUuid(),
              script: ctaScript,
              type: 'pause',
              metadata: {
                thumb: {
                  title: this.selectedPauseThumb.metadata.thumb.title,
                  startTime: this.selectedPauseThumb.startTime,
                  endTime: this.selectedPauseThumb.endTime,
                  hasButton:
                    this.selectedPauseThumb.metadata.thumb.hasButton || false,
                  type: 'pause',
                  lastAllVideo:
                    this.selectedPauseThumb.metadata.thumb.lastAllVideo ||
                    false,
                  lastTillEnd:
                    this.selectedPauseThumb.metadata.thumb.lastTillEnd || false,
                },
                fileUrl: thumbnail,
                thumbId: formInfo?.thumbFilename ?? this.generateUuid(),
              },
              startTime: this.selectedPauseThumb.startTime,
              endTime: this.selectedPauseThumb.endTime,
            }
          : false
        if (formInfo?.buttonMetadata && thumbnail) {
          codeThumbnail.metadata.button = formInfo.buttonMetadata
        }
      }
      if (type === 'endThumbnail') {
        codeThumbnail = {
          id: this.generateUuid(),
          script:
            `<img src='${thumbnail}' style='object-fit:cover; width:100%; height:100%;'><script>document.querySelector('img').onclick=function() { window.parent.postMessage({type: 'cta_play',}, '*') }</scr` +
            `ipt>`,
          type: 'end',
          metadata: {
            fileUrl: thumbnail,
          },
        }
      }
      return codeThumbnail
    },
    loadPublishedCtas() {
      const arrayCtas = this.$store.state.video.video.config?.ctas
      if (!arrayCtas) {
        return
      }
      if (this.video.hasOwnProperty('video_source')) {
        this.$root.$emit('setCtas', arrayCtas)
      } else {
        const iframe = document.getElementById('panda-player').contentWindow
        iframe.postMessage(
          {
            type: 'ctas',
            parameter: {
              ctas: arrayCtas,
            },
          },
          '*'
        )
        return
      }
    },
    getDefaultPauseThumbObj() {
      return {
        startTime: 0,
        endTime: this.$store.state.video.video?.length,
        type: 'pause',
        metadata: {
          thumb: {
            title: '',
            hasButton: false,
          },
        },
        id: uuidv4(), //temp id
      }
    },
    async handleDeleteThumbnail(removeButton, isUploadImage) {
      this.loadingRemoveDefault = true
      this.successfulDeleteThumb = false
      this.successfulChangedThumb = false
      this.clearErrors()
      if (!isUploadImage) this.loadingDeleteThumb = true
      try {
        const ret = await videosApi.deleteThumbnailVideo(this.videoId)
        await this.getVideoConfig(this.videoId)
        if (isUploadImage) this.loadingDeleteThumb = false
        this.defaultThumbnail = this.$store.state.video.video.thumbnail
        this.successfulDeleteThumb = true
        const text = this.$i18next.t(
          'message.pages.video.thumbnails.removeThumb'
        )
        this.selectedDefaultStart = this.defaultThumbnail
        if (removeButton === 'removeButton') {
          this.defaultTempStartThumbnail =
            this.$store.state.video.video.thumbnail
          this.UPDATE_GLOBAL_SNACKBAR({ open: true, text, type: 'success' })
          this.successfulDeleteThumb = true
        }
        this.$root.$emit('updateEmbedPreviewChange')
        if (!isUploadImage) this.loadingRemoveDefault = false
        return ret
      } catch (error) {
        this.loadingDeleteThumb = false
        this.loadingRemoveDefault = false
        this.errors.updateThumbnailVideo = true
        this.$root.$emit('updateEmbedPreviewChange')
      }
    },
    async handleRemoveThumb(pauseCta, index = 0) {
      if (!pauseCta.metadata.thumbId) {
        this.pauseThumbnails.splice(index, 1)
        return
      }
      await this.handleDeletePauseThumbnail(
        pauseCta.id,
        pauseCta.metadata.thumbId,
        true
      )

      this.pauseThumbnails = this.pauseThumbnails.filter(
        (item) => item.id !== pauseCta.id
      )
      this.originalPauseThumbnailsList = _.cloneDeep(this.pauseThumbnails)

      this.selectedPauseThumb =
        this.pauseThumbnails[0] || this.getDefaultPauseThumbObj()
      this.checkIfSelectedPauseThumbHasButton()
      this.handlePlayerPreviewPauseThumb()
      this.isEditingThumb = this.arrayCtas.length === 0
      if (!this.pauseThumbnails.length) {
        this.showEditPauseThumbs = false
      }
      const text = this.$i18next.t('message.pages.video.thumbnails.removeThumb')

      this.UPDATE_GLOBAL_SNACKBAR({ open: true, text, type: 'success' })
      if (!this.pauseThumbnails.length) {
        this.showEditPauseThumbs = false
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async handleDeletePauseThumbnail(
      ctaId,
      thumbFilename,
      shouldRemoveThumbFile,
      updateBehavior = false
    ) {
      this.loading = true
      this.successfulDeletePauseThumb = false
      this.successfulChangedPauseThumb = false
      this.clearErrors()
      this.loadingDeletePauseThumb = true
      try {
        let ret
        if (shouldRemoveThumbFile) {
          this.beingDeletePauseThumbId = ctaId
          ret = await videosApi.deleteThumbnailPauseVideo(
            this.videoId,
            thumbFilename
          )
        }
        const res = await playerApi.deleteCta(this.videoId, ctaId)
        await this.getVideoConfig(this.videoId)
        this.arrayCtas = res.data.ctas
        this.UPDATE_VIDEO_CONFIG_CTAS(this.arrayCtas)
        if (!updateBehavior) {
          this.pauseThumbnails = this.pauseThumbnails.filter(
            (item) => item.id !== ctaId
          )
        }
        this.originalPauseThumbnailsList = _.cloneDeep(this.pauseThumbnails)
        this.loadPublishedCtas()
        this.loadingDeletePauseThumb = false
        this.defaultPauseThumbnail = null
        this.havePauseThumb = false
        this.beingDeletePauseThumbId = ''
        this.loading = false
        return ret
      } catch (error) {
        console.error(error)
        this.loadingDeletePauseThumb = false
        this.havePauseThumb = true
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async handleDeleteEndThumbnail(removeButton = null) {
      this.loadingRemoveEnd = true
      this.successfulDeleteEndThumb = false
      this.successfulChangedEndThumb = false

      this.clearErrors()
      this.loadingDeleteEndThumb = true
      this.closeDialog()
      try {
        const found = _.filter(this.arrayCtas, { type: 'end' })
        let res

        for (let i = 0; i < found.length; i++) {
          try {
            await videosApi.deleteThumbnailEndVideo(this.videoId)
          } catch {}
        }

        for (const { id } of found) {
          res = await playerApi.deleteCta(this.videoId, id)
        }

        this.defaultEndThumbnail = null
        await this.getVideoConfig(this.videoId)

        this.arrayCtas = res.data.ctas
        this.UPDATE_VIDEO_CONFIG_CTAS(this.arrayCtas)

        this.UPDATE_STATUS_ERROR(false)

        this.loadPublishedCtas()
        this.loadingDeleteEndThumb = false
        this.haveEndThumb = false

        if (removeButton === 'removeButton') {
          this.successfulDeleteThumb = true
        }
        this.loadingRemoveEnd = false
      } catch (error) {
        this.loadingDeleteEndThumb = false
        this.haveEndThumb = true
        this.loadingRemoveEnd = false
      }
      const text = this.$i18next.t('message.pages.video.thumbnails.removeThumb')
      this.UPDATE_GLOBAL_SNACKBAR({ open: true, text, type: 'success' })
      this.$root.$emit('updateEmbedPreviewChange')
    },
    thumbnailHas(value) {
      const arrayCtas = this.$store.state.video.video.config?.ctas

      if (!arrayCtas) return false

      return arrayCtas.some((item) => item.type === value)
    },
    generateUuid() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      )
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
    },
    handleSnackbar(item) {
      if (!item) {
        item = this.$i18next.t('message.pages.video.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
    formatSecondsToTime(seconds) {
      let res = new Date(seconds * 1000).toISOString()
      if (this.timeVideo < 3600) {
        return res.substring(14, 19)
      }
      return res.substring(11, 19)
    },
    formatTimeToSeconds(time) {
      let res = time.split(':').reduce((acc, time) => 60 * acc + +time)
      return res
    },
    formatVideoLength() {
      let videoLength = this.$store.state.video.video?.length
      this.timeVideo = videoLength
    },
    handleStartTimeEvent(val) {
      this.selectedPauseThumb.metadata.thumb.lastAllVideo = false
      this.selectedPauseThumb.startTime = this.formatTimeToSeconds(val)
      this.handlePlayerPreviewPauseThumb()
    },
    handleEndTimeEvent(val) {
      this.selectedPauseThumb.metadata.thumb.lastTillEnd = false
      this.selectedPauseThumb.endTime = this.formatTimeToSeconds(val)
      this.handlePlayerPreviewPauseThumb()
    },
    handleLastAllVideo() {
      this.showAllPause = !this.selectedPauseThumb.metadata.thumb.lastAllVideo
      if (this.selectedPauseThumb.metadata.thumb.lastAllVideo) {
        this.selectedPauseThumb.startTime = this.formatTimeToSeconds(
          this.getDefaultTimes().start
        )
        this.selectedPauseThumb.endTime = this.timeVideo
        this.selectedPauseThumb.metadata.thumb.lastTillEnd = false
      }
      this.renderTick += 1
      this.handlePlayerPreviewPauseThumb()
    },
    toggleLastAllVideoState() {
      if (this.showAllPause)
        return (this.selectedPauseThumb.metadata.thumb.lastAllVideo = false)
      this.selectedPauseThumb.metadata.thumb.lastAllVideo = true
      this.handleLastAllVideo()
    },
    handleLastTillEnd() {
      if (this.selectedPauseThumb.metadata.thumb.lastTillEnd) {
        this.selectedPauseThumb.endTime = this.timeVideo
        this.selectedPauseThumb.metadata.thumb.lastAllVideo = false
      }
      this.renderTick += 1
      this.handlePlayerPreviewPauseThumb()
    },
    getDefaultTimes() {
      if (this.timeVideo && this.timeVideo >= 3600) {
        return {
          start: '00:00:00',
          end: '00:05:00',
        }
      }
      return {
        start: '00:00',
        end: '00:05',
      }
    },
    getEndThumbUrl() {
      if (this.thumbnailHas('end')) {
        const arrayCtas = this.$store.state.video.video.config?.ctas
        const endThumbnail = arrayCtas.find((item) => item.type === 'end')
        const htmlString = endThumbnail.script
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = htmlString
        const imgElement = tempDiv.querySelector('img')
        const thumbUrl = imgElement.getAttribute('src')
        return thumbUrl
      }
      return false
    },
    isValidImage(image) {
      return image
    },
    discardChanges() {
      this.loadingSlider = true
      this.defaultThumbnail = this.$store.state.video.video?.thumbnail
      this.defaultTempStartThumbnail = this.defaultThumbnail
      this.selectedDefaultStart = this.defaultThumbnail
      this.formatVideoLength()
      this.getVideoDefaultThumbs()
      this.videoId = this.liveVideoId ?? this.$route.params.id
      this.arrayCtas = this.$store.state.video.video.config?.ctas ?? []
      this.smartAutoPlay = this.$store.state.video.profile?.vsl?.autoplay
      this.defaultThumbnail = this.$store.state.video.video?.thumbnail
      if (this.$store.state.video.video?.endThumbnail) {
        this.defaultEndThumbnail = this.$store.state.video.video?.endThumbnail
      } else {
        this.defaultEndThumbnail = null
        const existsEndCta = this.arrayCtas.find((item) => item.type === 'end')
        if (existsEndCta) {
          if (existsEndCta.metadata && existsEndCta.metadata.fileUrl) {
            this.defaultEndThumbnail = existsEndCta.metadata.fileUrl
          } else {
            try {
              const imgUrl = existsEndCta.script.match(/src='([^']*)'/)[1]
              if (imgUrl) {
                this.defaultEndThumbnail = imgUrl
              }
            } catch (error) {
              console.log('failed to get end thumb from cta')
            }
          }
        }
      }

      let pauseThumbs = this.arrayCtas.filter((item) => item.type === 'pause')
      let mappedPauseThumbs = pauseThumbs.map((item) => {
        if (item.metadata) return item
        else {
          let thumbFilename =
            this.$store.state.video.video?.config.pauseThumbnail

          return {
            ...item,
            metadata: {
              thumb: {
                ...this.editingThumbnail,
                title: 'Thumb',
                type: 'pause',
                hasButton: false,
              },
              fileUrl: this.$store.state.video.video?.pauseThumbnail,
              thumbId: thumbFilename,
            },
            startTime: 0,
            endTime: this.$store.state.video.video?.length,
          }
        }
      })

      this.pauseThumbnails = mappedPauseThumbs
      this.originalPauseThumbnailsList = _.cloneDeep(this.pauseThumbnails)

      this.selectedPauseThumb = this.getDefaultPauseThumbObj()

      // this.$root.$on('buttonsFormInfo', (createdBtnInfo) => {
      //   this.selectedPauseThumb.metadata.button = createdBtnInfo.buttonMetadata
      //   this.selectedPauseThumb.metadata.thumb.hasButton = true
      //   this.handleUploadPauseThumbnail(createdBtnInfo)
      // })
      this.unsavedChanges = false
      this.loadingSlider = false
    },
    formatTime(timeString) {
      if (!timeString) return '00:00'

      const totalSeconds = parseFloat(timeString)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = Math.floor(totalSeconds % 60)

      const formattedMinutes = String(minutes).padStart(2, '0')
      const formattedSeconds = String(seconds).padStart(2, '0')

      if (hours > 0) {
        const formattedHours = String(hours).padStart(2, '0')
        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
      } else {
        return `${formattedMinutes}:${formattedSeconds}`
      }
    },
  },
}
</script>

<style lang="scss">
.v-input--selection-controls__input {
  margin-right: 0px;
}
.no-hover:hover::before {
  background-color: unset !important;
  opacity: unset !important;
}
.color-back {
  color: varFigma(brand-60-base) !important;
}
.neutral-20-dark-text {
  color: varFigma(neutral-20-dark) !important;
}
.subtitle-edit-dialog,
.title-enable-thumb {
  color: varFigma(neutral-20-dark);
}
.subTitle-enable-thumb {
  color: varFigma(neutral-40-light) !important;
}

.card-thumbnail {
  border: 2px dashed #d0d1d9 !important;
  box-shadow: none !important;
  border-radius: 4px;
  padding: 12px 16px;
}

.card-current-thumb {
  box-shadow: none !important;
}

.card-thumbnail .v-icon.v-icon::after {
  background-color: transparent !important;
}
.preview-image {
  background-repeat: no-repeat !important;
  background-size: 100% 100% !important;
  background-position: center !important;
  display: flex;
}
.card-thumbnail .v-icon {
  width: 150px !important;
  height: 92px !important;
  z-index: 2;
}

.card-thumbnail .v-icon:before {
  margin-top: -25px !important;
}

.card-thumbnail .v-input__icon {
  width: 150px !important;
  height: 100%;
  z-index: 2;
  opacity: 0;
}

.card-thumbnail .v-input {
  padding: 0 !important;
}

.card-thumbnail .v-input__prepend-outer {
  margin-right: 0 !important;
}

.container__thumb-list {
  overflow-y: hidden;
  overflow-x: auto;
  padding: 8px 0px !important;
}

.container__thumb-list::-webkit-scrollbar {
  height: 2px;
}

.container__thumb-list::-webkit-scrollbar-track {
  background: #edeef1;
}

.container__thumb-list::-webkit-scrollbar-thumb {
  background: var(--v-brand-base);
  border-radius: 8px;
}
.chip-enabled {
  background: varFigma(brand-90);
  color: varFigma(brand-20);
}
.hide-icon-time-picker {
  width: 52px;
}
.hide-icon-time-picker > .ant-time-picker-icon {
  display: none;
}
.dropdown-list {
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
</style>

<style lang="scss" scoped>
.neutral-60--text {
  color: varFigma(neutral-60);
}
::v-deep .v-list-item {
  cursor: pointer;
  transition: background-color 0.3s;
}

::v-deep .v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

::v-deep .v-list-item.theme--dark:hover {
  background-color: #292b35 !important;
}

::v-deep .v-list-item__title.disabled-v-list-item-title {
  color: varFigma(neutral-70) !important;
}
::v-deep .v-list-item__title.remove-v-list-item-title {
  color: varFigma(feedback-danger) !important;
}
.disabled-v-list-item {
  cursor: not-allowed;
}
::v-deep .v-text-field__slot .v-label {
  margin-left: -10px;
}
::v-deep .v-radio:has(i.mdi-radiobox-marked)::before {
  width: 18px;
  height: 18px;
  left: 3px;
  border: 5px solid var(--brand-60-base-light);
  top: unset;
}
::v-deep .v-radio:has(i.mdi-radiobox-marked)::after {
  width: 14px;
  height: 14px;
  left: 3px;
  top: unset;
}
::v-deep .v-list-item__title {
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 150% !important; /* 18px */
  color: varFigma(neutral-30) !important;
}
::v-deep .v-radio {
  margin-bottom: 16px;
}
::v-deep .v-menu__content {
  border-radius: var(--spacing-01, 2px) !important;
  border: 1px solid varFigma(neutral-95-lightest) !important;
  background: varFigma(neutral-100-white) !important;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15) !important;
}
::v-deep .error-timer input {
  border-color: varFigma(feedback-danger-light) !important;
  background-color: varFigma(feedback-danger-background) !important;
  color: varFigma(feedback-danger) !important;
}
.base-button.panda-icons.--thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  width: 32px !important;
  padding: 3px;
  height: 32px;
}
.panda-menu-action {
  margin-left: 16px;
}
.dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #9c27b0;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  background-color: #f9f9f9;
}
.dropzone:hover {
  background-color: #f1f1f1;
}
.d-none {
  display: none;
}
.edit-thumb-btn {
  background-color: transparent;
  border-width: 0px;
}
</style>
